<template>
  <pdf-a4-page no-margin :pdf-key="lang">
    <div class="landingpage-background w-screen h-screen">
      <div class="flex flex-col justify-between" style="height: 1020px">
        <tng-header :ba="ba" :immobilie="immobilie" :lang="lang"/>
        <div class="text-xs text-gray-500">Zuwegung Mast > Geländebeschaffenheit (Gefälle/Ausholzung/Rodung/Zuwegung)</div>
        <div class="text-xl md:text-xl font-bold">Zuwegung Mast</div>
        <div class="content h-full max-h-full">
          <div class="mt-0 grid grid-cols-8 justify-items-stretch items-center gap-y-3">
            <div class="text-lg md:text-lg col-span-8">Geländebeschaffenheit</div>
            <div class="col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor">Frage</div>
            <div class="text-sm font-bold col-span-3 border-solid rounded-md whiteYellowBorderColor">Beschreibung/Eingabewerte</div>
            <div class="col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor">Weitere Eingaben</div>
            <div class="col-span- text-sm font-bold border-solid rounded-md whiteYellowBorderColor">Bewertung</div>

<!-- Gefälle start-->
            <is-vorhanden-char-and-label
              :ba="ba"
              fragesPath="tng-be-flaechen.zuwegung-mast-tab.gefaelle.gefaelle-vorhanden"
              label="Gefälle"
              class="col-span-2"
            />
            <div class="text-xs text-gray-500 col-span-5">
              {{ useIdentifierFrageFinder(ba, 'tng-be-flaechen.zuwegung-mast-tab.gefaelle.gefaelle-beschreibung')?.['eingabeText'] }}
            </div>
            <bewertung-chip
              fragesPath="tng-be-flaechen.zuwegung-mast-tab.gefaelle.gefaelle-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
            <oneto-five-image-div
              :ba="ba"
              :immobilie="immobilie"
              fragesPath="tng-be-flaechen.zuwegung-mast-tab.gefaelle.gefaelle-bilder"
              :lang="lang"
              class="col-span-8"
            />
<!-- Gefälle Ende-->

<!-- Ausholzung Start -->
            <is-vorhanden-char-and-label
              :ba="ba"
              fragesPath="tng-be-flaechen.zuwegung-mast-tab.ausholzung.ausholzung-erforderlich"
              label="Ausholzung erforderlich"
              class="col-span-2"
            />
            <div class="text-xs text-gray-500 col-span-3">
              {{ useIdentifierFrageFinder(ba, 'tng-be-flaechen.zuwegung-mast-tab.ausholzung.ausholzung-beschreibung')?.['eingabeText'] }}
            </div>
            <div class="text-xs">Bereich:</div>
            <div class="text-xs text-gray-500">
              {{getAuswahlLabel(ba, 'tng-be-flaechen.zuwegung-mast-tab.ausholzung.ausholzung-bereich') }}
             </div>
            <bewertung-chip
              fragesPath="tng-be-flaechen.zuwegung-mast-tab.ausholzung.ausholzung-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
            <oneto-five-image-div
              :ba="ba"
              :immobilie="immobilie"
              fragesPath="tng-be-flaechen.zuwegung-mast-tab.ausholzung.ausholzung-bilder"
              :lang="lang"
              class="col-span-8"
            />
<!-- Ausholzung ende-->

<!-- Rodung Start-->
            <is-vorhanden-char-and-label
              :ba="ba"
              fragesPath="tng-be-flaechen.zuwegung-mast-tab.rodung.rodung-erforderlich"
              label="Rodung erforderlich"
              class="col-span-2"
            />
            <div class="text-xs text-gray-500 col-span-3">
              {{ useIdentifierFrageFinder(ba, 'tng-be-flaechen.zuwegung-mast-tab.rodung.rodung-beschreibung')?.['eingabeText'] }}
            </div>
            <div class="text-xs">Anzahl Bäume:</div>
            <div class="text-xs text-gray-500">
              {{ useIdentifierFrageFinder(ba, 'tng-be-flaechen.zuwegung-mast-tab.rodung.anzahl-baeume')?.['eingabeText'] }}
            </div>

            <bewertung-chip
              fragesPath="tng-be-flaechen.zuwegung-mast-tab.rodung.rodung-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
            <oneto-five-image-div
              :ba="ba"
              :immobilie="immobilie"
              fragesPath="tng-be-flaechen.zuwegung-mast-tab.rodung.rodung-bilder"
              :lang="lang"
              class="col-span-8"
            />
<!-- Rodung Ende-->
<!-- Zuwegung Wegeart Start-->
<div class="text-xs col-span-2">Zuwegung Wegeart</div>
    
              <div class="text-xs text-gray-500 col-span-5">
                {{useIdentifierFrageFinder(ba,'tng-be-flaechen.zuwegung-mast-tab.zuwegung-wegeart.zuwegung-wegeart-beschreibung')?.getSelectedAuswahlLabelsString() }} 
            </div>
            <bewertung-chip
              fragesPath="tng-be-flaechen.zuwegung-mast-tab.zuwegung-wegeart.zuwegung-wegeart-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
<!-- Zuwegung Wegeart Ende-->
<!-- Zuwegung Laenge Start-->
            <div class="text-xs col-span-2">Zuwegung Länge</div>
            <div class="text-xs text-gray-500 col-span-5">
              {{ 
                useIdentifierFrageFinder(ba, 'tng-be-flaechen.zuwegung-mast-tab.zuwegung-laenge.zuwegung-laenge-m')?.['eingabeText'] 
                  ? useIdentifierFrageFinder(ba, 'tng-be-flaechen.zuwegung-mast-tab.zuwegung-laenge.zuwegung-laenge-m')?.['eingabeText'] + " m" 
                  : "-" 
              }}
            </div>
            <bewertung-chip
              fragesPath="tng-be-flaechen.zuwegung-mast-tab.zuwegung-laenge.zuwegung-laenge-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
<!-- Zuwegung Laenge Ende-->
<!-- Zuwegung Breite-->
            <div class="text-xs col-span-2">Zuwegung Breite von-bis</div>
            <div class="text-xs text-gray-500 col-span-3">
              {{ 
                useIdentifierFrageFinder(ba, 'tng-be-flaechen.zuwegung-mast-tab.zuwegung.zuwegung-breitevonbis')?.['eingabeText'] 
                  ? useIdentifierFrageFinder(ba, 'tng-be-flaechen.zuwegung-mast-tab.zuwegung.zuwegung-breitevonbis')?.['eingabeText'] + " m" 
                  : "-" 
              }}
            </div>
            <div class="text-xs text-gray-500 col-span-2">
              {{ useIdentifierFrageFinder(ba,'tng-be-flaechen.zuwegung-mast-tab.zuwegung.zuwegung-breite-beschreibung')?.['eingabeText'] }}
            </div>
            <bewertung-chip
              fragesPath="tng-be-flaechen.zuwegung-mast-tab.zuwegung.zuwegung-breite-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
<!-- Zuwegung Breite Ende-->
<!-- Zuwegung Hoehe-->
            <div class="text-xs col-span-2">Zuwegung Höhe</div>
            <div class="text-xs">
              Start
            </div>
            <div class="text-xs text-gray-500 col-span-2">
              {{ 
                useIdentifierFrageFinder(ba, 'tng-be-flaechen.zuwegung-mast-tab.zuwegung-hoehe.zuwegung-hoehe-start')?.['eingabeText'] 
                  ? useIdentifierFrageFinder(ba, 'tng-be-flaechen.zuwegung-mast-tab.zuwegung-hoehe.zuwegung-hoehe-start')?.['eingabeText'] + " m" 
                  : "-" 
              }}
            </div>
            <div class="text-xs">
              Ende
            </div>
            <div class="text-xs text-gray-500 col-span-2">
              {{ 
                useIdentifierFrageFinder(ba, 'tng-be-flaechen.zuwegung-mast-tab.zuwegung-hoehe.zuwegung-hoehe-ende')?.['eingabeText'] 
                  ? useIdentifierFrageFinder(ba, 'tng-be-flaechen.zuwegung-mast-tab.zuwegung-hoehe.zuwegung-hoehe-ende')?.['eingabeText'] + " m" 
                  : "-" 
              }}
            </div>
            <div class="text-xs col-span-2"></div>
            <div class="text-xs">
              Unterschied
            </div>
            <div class="text-xs text-gray-500 col-span-2">
              {{ 
                useIdentifierFrageFinder(ba, 'tng-be-flaechen.zuwegung-mast-tab.zuwegung-hoehe.zuwegung-hoehenunterschied')?.['eingabeText'] 
                  ? useIdentifierFrageFinder(ba, 'tng-be-flaechen.zuwegung-mast-tab.zuwegung-hoehe.zuwegung-hoehenunterschied')?.['eingabeText'] + " m" 
                  : "-" 
              }}
            </div>
            <div class="text-xs text-gray-500 col-span-2">
              {{ useIdentifierFrageFinder(ba,'tng-be-flaechen.zuwegung-mast-tab.zuwegung-hoehe.zuwegung-hoehe-beschreibung')?.['eingabeText'] }}
            </div>
            <bewertung-chip
              fragesPath="tng-be-flaechen.zuwegung-mast-tab.zuwegung-hoehe.zuwegung-hoehe-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
<!-- Zuwegung Hoehe Ende-->
<!-- GRID  ende-->
          </div>
        </div>
        <be-footer :ba="ba" :immobilie="immobilie" :lang="lang"/>
      </div>
    </div>
  </pdf-a4-page>
  <pdf-a4-page no-margin :pdf-key="lang">
    <div class="landingpage-background w-screen h-screen">
      <div class="flex flex-col justify-between" style="height: 1020px">
        <tng-header :ba="ba" :immobilie="immobilie" :lang="lang"/>
        <div class="text-xs text-gray-500">Zuwegung Mast > Geländebeschaffenheit (Beschränkung/Beschaffenheit/Ringverkehr/Ausweichflächen/Zufahrt/Sonstiges)</div>
        <div class="content h-full max-h-full">
          <div class="mt-0 grid grid-cols-8 justify-items-stretch items-center gap-y-3">
            <div class="text-lg md:text-lg col-span-8">Geländebeschaffenheit - Fortsetzung</div>
            <div class="col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor">Frage</div>
            <div class="text-sm font-bold col-span-3 border-solid rounded-md whiteYellowBorderColor">Beschreibung/Eingabewerte</div>
            <div class="col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor">Weitere Eingaben</div>
            <div class="col-span- text-sm font-bold border-solid rounded-md whiteYellowBorderColor">Bewertung</div>
            <!-- Beschränkung Start-->
            <is-vorhanden-char-and-label
              :ba="ba"
              fragesPath="tng-be-flaechen.zuwegung-mast-tab.beschraenkung.beschraenkung-vorhanden"
              label="Beschränkung vorhanden"
              class="col-span-2"
            />
            <div class="text-xs col-span-1">Art:</div>
            <div class="text-xs text-gray-500 col-span-2">
              <ul
                v-for="(v, key) in useIdentifierFrageFinder(
                  ba,
                  'tng-be-flaechen.zuwegung-mast-tab.beschraenkung.beschraenkung-art'
                )?.getSelectedAuswahlLabels()"
                :key="key"
                class=""
              >
                <li :key="key" class="text-xs text-gray-500">
                  {{ v.de }}
                </li>
              </ul>
            </div>
            <div class="text-xs text-xs">Gewicht:</div>
            <div class="text-xs text-gray-500">
              {{ 
                useIdentifierFrageFinder(ba, 'tng-be-flaechen.zuwegung-mast-tab.beschraenkung.beschraenkung-gewicht-wert')?.['eingabeText'] 
                  ? useIdentifierFrageFinder(ba, 'tng-be-flaechen.zuwegung-mast-tab.beschraenkung.beschraenkung-gewicht-wert')?.['eingabeText'] + " to" 
                  : "-" 
              }}
            </div>
            <bewertung-chip
              fragesPath="tng-be-flaechen.zuwegung-mast-tab.beschraenkung.beschraenkung-gewicht-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
            <div class="col-span-5"></div>
            <div class="text-xs text-xs">Höhe:</div>
            <div class="text-xs text-gray-500">
              {{ 
                useIdentifierFrageFinder(ba, 'tng-be-flaechen.zuwegung-mast-tab.beschraenkung.beschraenkung-hoehe-wert')?.['eingabeText'] 
                  ? useIdentifierFrageFinder(ba, 'tng-be-flaechen.zuwegung-mast-tab.beschraenkung.beschraenkung-hoehe-wert')?.['eingabeText'] + " m" 
                  : "-" 
              }}
            </div>
            <bewertung-chip
              fragesPath="tng-be-flaechen.zuwegung-mast-tab.beschraenkung.beschraenkung-hoehe-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
            <oneto-five-image-div
              :ba="ba"
              :immobilie="immobilie"
              fragesPath="tng-be-flaechen.zuwegung-mast-tab.beschraenkung.bilder-beschraenkung"
              :lang="lang"
              class="col-span-8"
            />
<!-- Beschränkung Ende-->
            <!-- Beschaffenheit start-->
            <div class="text-xs col-span-2">Beschaffenheit:</div>
            <div class="text-xs text-gray-500 col-span-5">
              <ul
                v-for="(v, key) in useIdentifierFrageFinder(
                  ba,
                  'tng-be-flaechen.zuwegung-mast-tab.beschaffenheit.beschaffenheit'
                )?.getSelectedAuswahlLabels()"
                :key="key"
                class=""
              >
                <li :key="key" class="text-xs text-gray-500">
                  {{ v.de }}
                </li>
              </ul>
            </div>
            <bewertung-chip
              fragesPath="tng-be-flaechen.zuwegung-mast-tab.beschaffenheit.beschaffenheit-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
<!-- Beschaffenheit Ende-->

            <!-- Ringverkehr Start-->
            <div class="text-xs col-span-2">Ringverkehr:</div>
            <div class="text-xs text-gray-500 col-span-3">
              {{ useIdentifierFrageFinder(ba, 'tng-be-flaechen.zuwegung-mast-tab.ringverkehr.ringverkehr-beschreibung')?.['eingabeText'] }}
            </div>
            <div class="text-xs">Möglich?</div>
            <div class="text-xs text-gray-500">
              {{ useIdentifierFrageFinder(ba,'tng-be-flaechen.zuwegung-mast-tab.ringverkehr.ringverkehr-moeglich')?.getSelectedAuswahlLabelsString() }}
            </div>
            <bewertung-chip
              fragesPath="tng-be-flaechen.zuwegung-mast-tab.ringverkehr.ringverkehr-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
<!-- Ringverkehr Ende-->

<!-- Ausweichflächen Start-->
            <div class="text-xs col-span-2">Ausweichflächen:</div>
            <div class="text-xs col-span-2">
              <span class="text-xs text-gray-500">
                {{ useIdentifierFrageFinder(ba, 'tng-be-flaechen.zuwegung-mast-tab.ausweichflaechen.ausweichflaechen')?.getSelectedAuswahlLabelsString() }}
              </span>
            </div>
            <div class="text-xs text-gray-500 col-span-3">
              {{ useIdentifierFrageFinder(ba, 'tng-be-flaechen.zuwegung-mast-tab.ausweichflaechen.ausweichflaechen-beschreibung')?.['eingabeText'] }}
            </div>
            <bewertung-chip
              fragesPath="tng-be-flaechen.zuwegung-mast-tab.ausweichflaechen.ausweichflaechen-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
<!-- Ausweichflächen Ende-->
 
<!-- Alternative Zufahrt Start-->
            <div class="text-xs col-span-2">Alternative Zufahrt:</div>
            <div class="text-xs text-gray-500 col-span-3">
              {{ useIdentifierFrageFinder(ba, 'tng-be-flaechen.zuwegung-mast-tab.alternative-zufahrt.alternative-zufahrt-beschreibung')?.['eingabeText'] }}
            </div>
            <div class="text-xs text-gray-500 col-span-2">
              {{ useIdentifierFrageFinder(ba,'tng-be-flaechen.zuwegung-mast-tab.alternative-zufahrt.alternative-zufahrt')?.getSelectedAuswahlLabelsString() }}
            </div>
            <bewertung-chip
              fragesPath="tng-be-flaechen.zuwegung-mast-tab.alternative-zufahrt.alternative-zufahrt-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
<!-- Alternative Zufahrt Ende-->

<!-- Sonstiges Start-->
            <is-vorhanden-char-and-label
              :ba="ba"
              fragesPath="tng-be-flaechen.zuwegung-mast-tab.sonstiges.sonstiges-vorhanden"
              label="Sonstiges"
              class="col-span-2"
            />
            <div class="text-xs text-gray-500 col-span-5">
              {{ useIdentifierFrageFinder(ba, 'tng-be-flaechen.zuwegung-mast-tab.sonstiges.sonstiges')?.['eingabeText'] }}
            </div>
            <bewertung-chip
              fragesPath="tng-be-flaechen.zuwegung-mast-tab.sonstiges.sonstiges-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
<!-- Sonstiges Ende-->

<!-- GRID  ende-->
          </div>
          <div class="text-lg md:text-lg">Bauwerke</div>
          <div v-if="(getBauwerke(ba)|| []) .length > 0">
            <div class="grid grid-cols-8 justify-items-stretch items-center">
              <div class="col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor">Frage</div>
              <div class="text-sm font-bold col-span-3 border-solid rounded-md whiteYellowBorderColor">Beschreibung/Eingabewerte</div>
              <div class="col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor">Weitere Eingaben</div>
              <div class="col-span- text-sm font-bold border-solid rounded-md whiteYellowBorderColor">Bewertung</div>
            </div>
            <div
              v-for="(bauwerk, key) in getBauwerke(ba)"
              :key="key"
              class="ml-2 mt-2 grid grid-cols-8 justify-items-stretch items-center"
              style="
                border-style: solid;
                border-color: var(--white100) var(--white100) var(--white100) rgb(216, 215, 26);
                border-radius: 5px;
              "
            >
              <div class="text-xs col-span-2 ml-2 mt-2">Bauwerke:</div>
              <div class="text-xs col-span-3 text-gray-500">
                {{ bauwerk['freitext'] }}
              </div>
              <div class="text-xs md:text-xs">Tragfähig:</div>
              <div class="text-xs text-gray-500 capitalize">
                {{ bauwerk['tragfaehig'] }}
              </div>
              <div class="justify-self-end row-span-2">
                <PdfChip
                  v-if="'plus' === bauwerk['bauwerk-bewertung']"
                  color="green"
                  mangel-amount-mode
                  value="1"
                  pdf-mode
                />
                <PdfChip
                  v-if="'o' === bauwerk['bauwerk-bewertung']"
                  color="blue"
                  mangel-amount-mode
                  value="1"
                  pdf-mode
                />
                <PdfChip
                  v-if="'minus' === bauwerk['bauwerk-bewertung']"
                  color="yellow"
                  mangel-amount-mode
                  value="1"
                  pdf-mode
                />
                <PdfChip
                  v-if="'x' === bauwerk['bauwerk-bewertung']"
                  color="red"
                  mangel-amount-mode
                  value="1"
                  pdf-mode
                />
              </div>
              <div class="col-span-2"></div>
              <div class="text-xs col-span-3 text-gray-500">
                {{ bauwerk['beschreibung'] }}
              </div>
              <oneto-five-image-div
                :ba="ba"
                :immobilie="immobilie"
                :lang="lang"
                :imageObjects="bauwerk['bild']"
                class="ml-2 col-span-8"
              />
            </div>
          </div>
          <div v-else> 
            <div
                class="justify-center items-center col-span-8"
                style="
                  background-color: rgb(235, 239, 240);
                  border-style: solid;
                  border-color: rgb(235, 239, 240) rgb(235, 239, 240)
                    rgb(235, 239, 240) rgb(235, 239, 240);
                  border-radius: 5px;
                "
              >
                <p class="text-xs text-center">Keine Bauwerke aufgenommen</p>
            </div>
          </div>
        </div>
        <be-footer :ba="ba" :immobilie="immobilie" :lang="lang"/>
      </div>
    </div>
  </pdf-a4-page>
         <!-- Zuwegung Mast Ökologie Page -->
  <pdf-a-4-page no-margin :pdf-key="lang">
    <div class="landingpage-background w-screen h-screen">
      <div class="flex flex-col justify-between" style="height:1020px">
        <tng-header :ba="ba" :immobilie="immobilie" :lang="lang"/>
        <div class="text-xs text-gray-500">Zuwegung Mast > Geländebeschaffenheit (Gräben)</div>
        <div class="content h-full max-h-full">
          <div class="mt-4 text-lg md:text-lg">Gräben</div>
<!-- Geplante Baumaßnahme Content Ende-->
          <div v-if="(getGraben(ba) || []).length > 0">
            <div class="grid grid-cols-8 justify-items-stretch items-center">
              <div class="col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor">Frage</div>
              <div class="text-sm font-bold col-span-3 border-solid rounded-md whiteYellowBorderColor">Beschreibung/Eingabewerte</div>
              <div class="col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor">Weitere Eingaben</div>
              <div class="col-span- text-sm font-bold border-solid rounded-md whiteYellowBorderColor">Bewertung</div>
            </div>
            <div
              v-for="(graben, key) in getGraben(ba)"
              :key="key"
              class="ml-2 grid grid-cols-8 justify-items-stretch items-center"
              style="
                border-style: solid;
                border-color: var(--white100) var(--white100) var(--white100) rgb(216, 215, 26);
                border-radius: 5px;
              "
            >
            <div class="text-xs col-span-2 ml-2">Art: </div>
            <div class="text-xs col-span-3 capitalize"> 
              {{ graben['art'].replace(/-/g, ' ') }}
            </div>
            <div class="text-xs text-gray-500 col-span-2">
              {{ graben['graben-beschreibung'] }}
            </div>
            <div class="justify-self-end row-span-2">
              <PdfChip
                v-if="'plus' === graben['graben-bewertung']"
                color="green"
                mangel-amount-mode
                value="1"
                pdf-mode
              />
              <PdfChip
                v-if="'o' === graben['graben-bewertung']"
                color="blue"
                mangel-amount-mode
                value="1"
                pdf-mode
              />
              <PdfChip
                v-if="'minus' === graben['graben-bewertung']"
                color="yellow"
                mangel-amount-mode
                value="1"
                pdf-mode
              />
              <PdfChip
                v-if="'x' === graben['graben-bewertung']"
                color="red"
                mangel-amount-mode
                value="1"
                pdf-mode
              />
            </div>
              <div class="col-span-2 text-xs ml-2">Abstand</div>
              <div class="text-xs text-gray-500 col-span-3">
                {{ graben['abstand'] ==null ? '': graben['abstand'] + " m"}}
              </div>
              <div class="text-xs text-gray-500 col-span-3">
                {{ graben['graben-typ'] }}
              </div>
              <oneto-five-image-div
                :ba="ba"
                :immobilie="immobilie"
                :lang="lang"
                :imageObjects="graben['graben-bilder']"
                class="ml-2 col-span-8"
              >
              </oneto-five-image-div>
            </div>
          </div>
          <div v-else>
            <div class="mt-2 grid grid-cols-8 justify-items-stretch items-center">
              <div
                class="justify-center items-center col-span-8"
                style="
                  background-color: rgb(235, 239, 240);
                  border-style: solid;
                  border-color: rgb(235, 239, 240) rgb(235, 239, 240)
                    rgb(235, 239, 240) rgb(235, 239, 240);
                  border-radius: 5px;
                "
              >
                <p class="text-xs text-center">Keine Grabenquerungen aufgenommen</p>
              </div>
            </div>
          </div>
        </div>
        <be-footer :ba="ba" :immobilie="immobilie" :lang="lang"/>
      </div>
    </div>
  </pdf-a-4-page>
  <Oekologie :ba="ba" :immobilie="immobilie" :lang="lang" :oekologie="ba.findFragenblockByRelativePath('zuwegung-mast-tab.oekologie-group')!" bread-crumb="Zuwegung Mast > Ökologie" tab="Zuwegung"/>

     <!-- ###################### -->
</template>

<script lang="ts">
import useUser from '@/composables/useUser';
import Bestandsaufnahme from '@/models/ba/Bestandsaufnahme';
import Immobilie from '@/models/immobilie.model';
import { defineComponent, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import moment from 'moment';
import { useIdentifierFrageFinder, getAuswahlLabel } from '@/composables/Bestandsaufnahme/useIdentifierFinder';
import { getPhotoUrl } from '@/utilities/get-media-url';
import PdfA4Page from '@/components/Pdf/Components/PdfA4Page.vue';
import PdfChip from '../Components/PdfChip.vue';
import { useGesamtflaechen } from './PageElements/useGesamtflaechen';
import UniversalPdfImageRow from '../Components/UniversalPdfImageRow.vue';
import TngHeader from './PageElements/TngHeader.vue';
import BeFooter from './PageElements/BeFooter.vue';
import OnetoFiveImageDiv from './PageElements/OnetoFiveImageDiv.vue';
import BewertungChip from './PageElements/BewertungChip.vue';
import isVorhandenCharAndLabel from './PageElements/isVorhandenCharAndLabel.vue';
import Oekologie from './PageElements/Oekologie.vue';

export default defineComponent({
  name: 'ZuwegungMast',
  components: {
    PdfA4Page,
    PdfChip,
    UniversalPdfImageRow,
    TngHeader,
    BeFooter,
    OnetoFiveImageDiv,
    BewertungChip,
    isVorhandenCharAndLabel,
    Oekologie
  },
  props: {
    ba: {
      type: Object as PropType<Bestandsaufnahme>,
      required: true,
    },
    immobilie: {
      type: Object as PropType<Immobilie>,
      required: true,
    },
    lang: {
      type: String,
      default: 'de',
    },
  },
  setup(props: any) {
    const { t } = useI18n({ useScope: 'global' });
    const uUser = useUser();
    const { getGraben, getBauwerke } = useGesamtflaechen();
   
    return {
      
      user: uUser.user,
      t,
      useIdentifierFrageFinder,
      moment,
      getPhotoUrl,
      getGraben,
      getBauwerke,
      getAuswahlLabel
    };
  },
});
</script>
<style scoped>
  * {
    color: rgb(23, 68, 81);
    font-family: var(--secondaryFont);
  }
  .pdf-content {
    width: 800px;
    margin: 0 auto;
    color: var(--white100);
  }
  .landingpage-background {
    position: absolute;
    top: 50px;
    left: 50px;
    width: 700px;
    height: 1050px;
    color: black;
  }
  .trenner {
    height: 3px;
    border-width: 1;
    background-color: rgb(23,68,81);
  }
  .content {
    height: 870px;
  }
</style>